import { SALES_DESK_NAV, type SalesDeskPage } from "./salesDeskStyles";

export function SalesDeskNav({
  page,
  onChange,
}: {
  page: SalesDeskPage;
  onChange: (page: SalesDeskPage) => void;
}) {
  if (page === "configure") return null;
  return (
    <nav className="fixed inset-x-0 bottom-0 z-10 flex justify-around border-t border-[#dce3dc] bg-white px-2 py-2 dark:border-zinc-800 dark:bg-zinc-950">
      {SALES_DESK_NAV.map((item) => {
        const active = page === item.id;
        return (
          <button
            key={item.id}
            type="button"
            onClick={() => onChange(item.id)}
            className={`flex min-w-[55px] flex-col items-center text-[11px] ${active ? "text-[#164b43]" : "text-[#687772] dark:text-zinc-400"}`}
          >
            <span className="text-[22px] leading-none text-[#164b43]">{item.glyph}</span>
            {item.label}
          </button>
        );
      })}
    </nav>
  );
}
